import gql from 'graphql-tag';

import { LINK_PREVIEW_METADATA_DETAILS_FRAGMENT } from '../LinkMetadataDetails/linkPreviewMetadataDetails';

export const LINK_PREVIEW_METADATA_FRAGMENT = gql`
  fragment linkPreviewMetadata on LinkMetadata {
    id
    details {
      ...linkPreviewMetadataDetails
    }
  }

  ${LINK_PREVIEW_METADATA_DETAILS_FRAGMENT}
`;
